import { Module } from "vuex";
import { RootState } from "@/store/type";
import { CustomerState } from "@/store/customer/type";
import { getters } from "@/store/customer/getters";
import { actions } from "@/store/customer/actions";
import { mutations } from "@/store/customer/mutations";

const defaultState: CustomerState = {
  me: null
};

export const customer: Module<CustomerState, RootState> = {
  state: defaultState,
  getters,
  mutations,
  actions
};




